import * as models from "app/models/requireme";
import { componentToRx } from "app/logic/rx";

export { obtenerServicios, Cotizacion, CotizacionConcepto, CotizacionGrupo } from "app/logic/operativa/cotizacion";
import { obtenerFletes as obtenerFletesImport, obtenerServicios, Cotizacion, CotizacionGrupo } from "app/logic/operativa/cotizacion";

import * as kearegex from "kea-regex";

/**Obtiene la información de cotización de una guia */
export function obtenerCotizacionDeGuia(guia: models.GuiaDTO): Cotizacion {
    const envio = obtenerFletes(guia.Paquetes, guia.Sobres, guia.DistanciaFlete);
    const servicios = obtenerServicios(guia.Importes, {
        EntregaDomicilio: !!guia.ServiciosAdicionales.EntregaDomicilio,
        RecoleccionDomicilio: !!guia.ServiciosAdicionales.RecoleccionDomicilio,
        TipoAcuse: guia.ServiciosAdicionales.TipoAcuse
    });

    return {
        grupos: [envio, servicios],
        descuentoFlete: guia.Importes.ImporteDescuentoFlete,
        flete: guia.Importes.Flete,
        subtotal: guia.Importes.Subtotal,
        iva: guia.Importes.Iva,
        retencionIva: guia.Importes.RetencionIva,
        total: guia.Importes.Total
    };
}

function obtenerFletes(paquetes: models.Paquete[], sobres: models.Sobre[], distanciaFlete: number): CotizacionGrupo {
    const cantSobres = sobres.map(x => x.Cantidad).reduce((a, b) => a + b, 0);
    const importeSobres = sobres.map(x => x.Importes!.Flete).reduce((a, b) => a + b, 0);
    const paqs = paquetes.map(x => ({ ...x, Importes: x.Importes! }));
    return obtenerFletesImport(paqs, cantSobres, importeSobres, distanciaFlete);
}

/**Determina si una cadena es un folio de una guia */
export function esFolio(folio: string) {
    const regex = kearegex.exact(kearegex.seq(
        kearegex.nTimes(kearegex.alphanum, 3),
        /-/,
        kearegex.nTimes(kearegex.digit, 4)));

    return regex.test(folio);
}

export function esClaveCliente(clave?: number) {
    const claveCadena = clave + "";
    const regex = kearegex.exact(kearegex.seq(
        kearegex.nTimes(kearegex.digit, 5))
    );
    return regex.test(claveCadena);
}




// WEBPACK FOOTER //
// ./app/logic/guias.tsx